import React, { Component } from 'react';
import { PICTURES} from '../../../../../../constants/app/files';
import InspectionTransform from '../../../../../../lib/utils/transforms/inspections';
import { USE_VEHICLE, TYPE_ENERGY } from '../../../../../../constants/app/vehicle';
import InfoCar from './info-car';
import GalleryCar from '../../../../../shared/gallery';
const Pictures = ({images = [], inspection = {}, onChangePictures = () => {}, handleSelect = () => {}, picturesObserveds = [], saveComment}) => {
	const galleryImages = images ? InspectionTransform.transformImages(images, PICTURES, 'pictureCode') : [];
	let useCar = USE_VEHICLE[inspection.carUseStatus];
	let energyCar = TYPE_ENERGY[inspection.fuelUseStatus];

	return(
		<div className="row row-tab-container">
			<InfoCar use={useCar} energy={energyCar} inspection={inspection} images={galleryImages} onChangePictures={onChangePictures} saveComment={saveComment}/> 
			<GalleryCar images={galleryImages} handleSelect={handleSelect('picture')} picturesObserveds={picturesObserveds} allImages={images} inspection={inspection}/>
		</div>
	)
};
export default Pictures;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/pictures/index.js